import ListItemText from "@material-ui/core/ListItemText";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import { withStyles } from "@material-ui/core/styles";
import MoreVert from "@material-ui/icons/MoreVert";
import { unwrapResult } from "@reduxjs/toolkit";
import { notification } from "antd";
import Button from "components/CustomButtons/Button.js";
import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { fetchPloById } from "reduxToolkit/features/PLO/PLOSpecSlice";
import { deletePloIndicator } from "reduxToolkit/features/PLOIndicator/PLOIndicatorSpecSlice";
import ErrorModal from "../../../Components/ErrorModal";
import SuperGeneralDeleteModal from "../../../Components/SuperGeneralDeleteModal";
import PLOAddCourse from "./PLOAddCourseModal";
import PLOEditModal from "./PLOEditModal";

const StyledMenu = withStyles({
  paper: {
    border: "1px solid #d3d4d5",
  },
})((props) => (
  <Menu
    elevation={0}
    getContentAnchorEl={null}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "right",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "right",
    }}
    {...props}
  />
));

export default function PLODropDownButton(props) {
  const { t } = useTranslation();

  const [open, setOpen] = React.useState(false);

  const handleOpenDeleteModal = () => {
    setOpen(true);
  };

  const handleCloseDeleteModal = () => {
    setOpen(false);
  };
  // const [openDeleteCourse, setOpenDeleteCourse] = React.useState(false);

  // const handleOpenDeleteCourseModal = () => {
  //   setOpenDeleteCourse(true);
  // };

  // const handleCloseDeleteCourseModal = () => {
  //   setOpenDeleteCourse(false);
  // };
  const [openErrorModal, setOpenErrorModal] = React.useState(false);
  const [handledError, setHandledError] = React.useState("");

  const handleOpenErrorModal = () => {
    setOpenErrorModal(true);
  };
  const handleCloseErrorModal = () => {
    setOpenErrorModal(false);
  };

  const [anchorEl, setAnchorEl] = React.useState(null);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const openNotificationWithIcon = (type, msg) => {
    notification[type]({
      message: type,
      description: msg,
      top: 50,
      duration: 2,
    });
  };

  const dispatch = useDispatch();

  return (
    <div>
      <Button
        // aria-describedby={id}
        aria-controls="customized-menu"
        variant="contained"
        color="primary"
        onClick={handleClick}
        justIcon
        round
        aria-haspopup="true"
      >
        <MoreVert />
      </Button>

      <StyledMenu
        id="customized-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <PLOEditModal handleDropDownButtonClose={handleClose} programId={props.programId} plo={props.plo} courses={props.courses}/>
        <PLOAddCourse handleDropDownButtonClose={handleClose} programId={props.programId} plo={props.plo} courses={props.courses}/>
        <MenuItem
          onClick={() => {
            handleOpenDeleteModal();
            handleClose();
          }}
        >
          <ListItemText primary="Delete PLO" />
        </MenuItem>
        {/* <MenuItem
          onClick={() => {
            handleOpenDeleteCourseModal();
            handleClose();
          }}
        >
          <ListItemText primary="Delete course" />
        </MenuItem> */}
      </StyledMenu>
      {/* <ErrorModal open={openErrorModal} handleClose={handleCloseErrorModal} handledError={handledError} /> */}
      <SuperGeneralDeleteModal
        delete_Element={props.handleDeletePlo}
        Element_ID={props.plo.id}
        open={open}
        handleClose={handleCloseDeleteModal}
      />
      {/* <SuperGeneralDeleteModal
        delete_Element={props.handleDeleteCoursePlo}
        Element_ID={props.id}
        open={open}
        handleClose={handleCloseDeleteCourseModal}
      /> */}
    </div>
  );
}
